import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from '../common/widget/valueBox'
import Row from '../common/layout/row'
import InfoBox from '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';

import imagemUser from '../assets/images/user.jpg';

import ViagemForm from '../viagem/viagemForm';
import ManutencaoForm from '../manutencao/manutencaoForm';

import { getListaVeiculoTipo } from '../dashboard/dashboardActions';
import { getLista as getListaVeiculoAlerta } from '../veiculoAlerta/veiculoAlertaActions';
import {
	setModoTela as setModoTelaViagem, initForm as initFormViagem, salvar as salvarViagem, excluir as excluirViagem,
	getLista as getListaViagem,
	getListaEstado,
	getListaCidade,
	getListaViagemStatus,
	getListaViagemLancamento,
	getListaLocal,
	getListaVeiculo,
	excluirVeiculo,
	getListaMotorista,
	getListaTransportadora,
	getListaProduto,
	getListaUnidadeMedida,
	getListaProximaCarga,
	getListaPosto,
	getListaRota,
	getListaCliente
} from '../viagem/viagemActions';

import {
	initForm as initFormManutencao, salvar as salvarManutencao, excluir as excluirManutencao
} from '../manutencao/manutencaoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import VeiculoAlerta from '../veiculoAlerta/veiculoAlerta';
import ColorUtils from '../common/colorUtils/ColorUtils';
import Select from '../common/form/select';

class Dashboard extends Component {

	state = {
		linhaSelecionada: null,
		terceiro: window.location.href.includes('terceiro'),
		pesquisar: ''
	}

	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.props.getListaViagem();
		this.props.getListaEstado();
		this.props.getListaCidade();
		this.props.getListaViagemStatus();
		this.props.getListaViagemLancamento();
		this.props.getListaLocal();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
		this.props.getListaTransportadora();
		this.props.getListaProduto();
		this.props.getListaUnidadeMedida();
		this.props.getListaProximaCarga();
		this.props.getListaPosto();
		this.props.getListaRota();
		this.props.getListaVeiculoAlerta();
		this.props.getListaVeiculoTipo();
		this.props.getListaCliente();

		setInterval(() => {
			this.props.getListaViagem();
			this.props.getListaVeiculoAlerta();
		}, 100000);



		this.setState({
			...this.state,
			terceiro: window.location.href.includes('terceiro'),
			relogio: `${DateFormat.getDiaSemana(new Date())}, ${DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())}`

		})

	}

	componentWillUpdate() {
		if (window.location.href.includes('terceiro') != this.state.terceiro) {
			this.setState({
				...this.state,
				terceiro: window.location.href.includes('terceiro')
			});
		}
	}

	render() {

		let dataDescargaAnterior = null;

		let idMotorista = this.props.sessao && this.props.sessao.id_motorista ? this.props.sessao.id_motorista : null;

		let acessoTV = this.props.sessao && (this.props.sessao.id == 43); //TV SALA LOGÍSTICA

		return (
			<Content>

				{this.modalVeiculo()}
				
				<Aguardando aguardando={this.props.aguardando} />

				{this.props.modoTelaViagem == 'cadastro' ? (
					<ViagemForm onSubmit={this.props.salvarViagem} />
				) : (this.props.modoTelaViagem == 'exclusao' ? (
					<ViagemForm excluir onSubmit={this.props.excluirViagem} />
				) : (this.props.modoTelaViagem == 'manutencaoCadastro' ? (
					<ManutencaoForm onSubmit={this.props.salvarManutencao} />
				) : (
					<div>

							{!acessoTV &&
							<Row>
								<Grid cols='12 8 9 9'>
									<input className='form-control'
										placeholder='Pesquisar'
										type='text'
										value={this.state.pesquisar}
										onChange={e => {
											this.setState({ ...this.state, pesquisar: e.target.value });
										}} />
								</Grid>
								<Select
									options={this.props.listaVeiculoTipo}
									label={null}
									cols='12 4 3 3'
									placeholder='Tipo do Veículo'
									multiple={true}
									value={this.props.listaVeiculoTipo.map(item => ({ value: item.id, label: item.valor })).filter(item => (this.state.ids_veiculo_tipo || []).includes(item.value))}
									onChange={value => {
										this.setState({
											...this.state,
											ids_veiculo_tipo: value.map(item => item.value)
										})
									}} />
							</Row>}

							<Table responsive striped style={{ maxHeight: '100%' }}>
									<Tr>
										<Th>Motorista</Th>
										<Th alignCenter>Placa</Th>
										<Th alignCenter>Status</Th>
										<Th alignCenter>Origem Carga</Th>
										<Th alignCenter>Data Carga</Th>
										<Th alignCenter>Destino Carga</Th>
										<Th alignCenter>Data Descarga</Th>
										<Th alignCenter>Agendamento</Th>
									</Tr>
								<TBody>

									{this.props.listaViagem.filter(item =>
										!idMotorista || idMotorista == item.id_motorista
									).filter(item => {
										if (this.state.pesquisar
											&& !(`${item.nome_motorista} ${item.placa_veiculo} ${item.dias_viagem} ${item.dias_fora} ${item.deslocamento_vazio ? 'D. Vazio' : item.nome_viagem_status}
													${item.documentacao ? 'Sim' : 'Não'} ${item.rota_abastecimento ? 'Sim' : 'Não'}
													${item.nome_cidade_carga} ${item.sigla_estado_carga} ${item.nome_usuario}
													${item.datahora_carga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga, false) : ''}
													${item.nome_cidade_descarga} ${item.sigla_estado_descarga} ${item.nome_transportadora} 
													${item.datahora_descarga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga, false) : ''}
												`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
											return false;
										}
										return true;

									}).filter(item => 
										item.veiculo_terceiro == this.state.terceiro
									).filter(item => !(this.state.ids_veiculo_tipo || []).length || (this.state.ids_veiculo_tipo || []).includes(item.id_veiculo_tipo)).map((item, i) => {

										let dataDescarga = item.datahora_descarga ? item.datahora_descarga.split(' ')[0] : '';
										let dataDiferente = false;
										if (dataDescargaAnterior != null && dataDescarga != dataDescargaAnterior) {
											dataDiferente = true;
										}
										dataDescargaAnterior = dataDescarga;

										const title =
													`Status: ${item.deslocamento_vazio ? 'D. Vazio' : (!item.km_inicial ? 'Agendado' : (!item.km_final ? 'Trânsito' : 'Finalizado'))} \n` +
													`Agendamento: ${item.datahora_agendamento ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento, false) : 'Não informado'} \n \n` +
													`Coleta / Entrega \n` +
													`${(item.itens || []).map((coletaEntrega, i) => (
														`${i+1}: ${coletaEntrega.nome_cidade_carga || ''} - ${coletaEntrega.sigla_estado_carga || ''} => ${coletaEntrega.nome_cidade_descarga || ''} - ${coletaEntrega.sigla_estado_descarga || ''}`
													)).join('\n')}` +
													`\n \n` +
													`Informações \n` +
													`${(item.itens || []).map((coletaEntrega, i) => (
														`Produto ${i+1}: ${coletaEntrega.nome_produto || 'não informado'} \n` +
														`Quantidade: ${FormatUtils.formatarValorTelaDecimal(coletaEntrega.quantidade || 0, 2)} ${coletaEntrega.nome_unidade_medida}`
													)).join('\n \n')}` +
													`\n` +
													`Agendado Por: ${item.responsavel_agendamento || ''} \n` +
													`Observação: ${item.observacao || ''} \n` ;

										const veiculoAlerta = this.props.listaVeiculoAlerta.filter(alerta => (alerta.id_veiculo == item.id_veiculo || alerta.id_veiculo == item.id_veiculo_controle) && !alerta.datahora_fim)[0];

										return (
											<Tr key={i}
												style={{ borderTop: dataDiferente ? '2px solid rgb(128, 128, 128)' : null }} >
												<Td title={title}>{item.nome_motorista}</Td>
												<Td alignCenter title={title}>
													<div 
														style={{
															backgroundColor: item.cor_veiculo_tipo,
															color: ColorUtils.getCorFonte(item.cor_veiculo_tipo || '#ffffff'),
															borderRadius: 8,
															padding: 4
														}}>
														{item.placa_veiculo}
													</div>
												</Td>												
												<Td alignCenter title={title} style={{ fontWeight: item.cor_viagem_status ? 'bold' : null, color: item.cor_viagem_status }}>{item.deslocamento_vazio ? 'D. Vazio' : item.nome_viagem_status}</Td>
												<Td alignCenter title={title}>{item.nome_cidade_carga} - {item.sigla_estado_carga}</Td>
												<Td alignCenter title={title}>{item.datahora_carga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga, false) : ''}</Td>
												<Td alignCenter title={title}>{item.nome_cidade_descarga} - {item.sigla_estado_descarga}</Td>
												<Td alignCenter title={title}>{item.datahora_descarga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga, false) : ''}</Td>
												<Td alignCenter title={title}>{(item.lista_agendadas || []).length ? 'Possui' : 'Não Possui'}</Td>
											</Tr>
										)
									})}
								</TBody>
							</Table>
					</div>
				)))}
			</Content>
		)
	}

	circularProgress(percent = 0) {

		const size = 34;
		const stroke = 4;
		const fontSize = 8;
		const radius = (size - stroke) / 2;
		const circumference = 2 * Math.PI * radius;

		const offset = circumference - (percent / 100) * circumference;

		return (
			<div style={{ width: size, height: size, position: 'relative' }}>
				<svg width={size} height={size}>
					{/* Fundo */}
					<circle
						stroke='#c9c3c3'
						fill='transparent'
						strokeWidth={stroke}
						r={radius}
						cx={size / 2}
						cy={size / 2}
					/>

					{/* Progresso */}
					<circle
						stroke='#4caf50'
						fill='transparent'
						strokeWidth={stroke}
						strokeLinecap='round'
						strokeDasharray={circumference}
						strokeDashoffset={offset}
						r={radius}
						cx={size / 2}
						cy={size / 2}
						style={{
							transition: 'stroke-dashoffset 0.5s ease'
						}}
					/>
				</svg>

				{/* Texto central */}
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: size,
						height: size,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: fontSize,
						fontWeight: 'bold'
					}}
				>
					{FormatUtils.formatarValorTela(percent, percent < 1 ? 1 : 0)}%
				</div>
			</div>
		);
	};

	modalVeiculo() {

		if (!this.state.modalVeiculo) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Alertas</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalVeiculo: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<VeiculoAlerta id_veiculo={this.state.modalVeiculo.id_veiculo} />
						</div>
					</div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.viagem.aguardando,
	listaViagem: state.viagem.lista,
	modoTelaViagem: state.viagem.modoTela,
	permissoes: state.usuario.permissoes,
	listaVeiculoAlerta: state.veiculoAlerta.lista,
	listaVeiculoTipo: state.dashboard.listaVeiculoTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getListaViagem, setModoTelaViagem, initFormViagem, salvarViagem, excluirViagem,
	getListaEstado,
	getListaCidade,
	getListaViagemStatus,
	getListaViagemLancamento,
	getListaLocal,
	getListaVeiculo,
	excluirVeiculo,
	getListaMotorista,
	getListaTransportadora,
	getListaProduto,
	getListaUnidadeMedida,
	getListaProximaCarga,
	getListaPosto,
	getListaRota,
	initFormManutencao, salvarManutencao, excluirManutencao,
	getListaVeiculoAlerta,
	getListaVeiculoTipo,
	getListaCliente
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
